import axios from 'axios/index'

const namespaced = true

const state = {
  appTypes: null
}

const actions = {
  getAppTypes ({ commit, state }, payload) {
    const url = '/api/private/v3.0/piportals/afb/app-types/'
    axios.get(url)
      .then(res => {
        commit('parseAppTypes', res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getLatestApp ({ commit, state }, payload) {
    const url = '/api/private/v3.0/piportals/afb/app-types/' + payload + '/latest/download/'
    return new Promise((resolve, reject) => {
      axios.get(url, { responseType: 'blob' })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  parseAppTypes (state, value) {
    for (let i = 0; i < value.data.length; i++) {
      value.data[i].clicked = false
    }
    state.appTypes = value.data
  },
  downloadClient (state, value) {
    let fileName = value.headers['content-disposition'].split('filename=')[1]
    fileName = fileName.substring(1, fileName.length - 1)
    const downloadUrl = window.URL.createObjectURL(new Blob([value.data], { type: value.type }))
    const link = document.createElement('a')
    link.href = downloadUrl
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(downloadUrl)
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
